import React, { useState } from "react";
import Header from "./Header";
import Cube from "./Cube";
import Footer from "./Footer";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";

// Importación de componentes de cada cara
import Web3Face from "./Web3Face";
import SCSecurityFace from "./SCSecurityFace";
import AIFace from "./AIFace";
import AppDesignFace from "./AppDesignFace";
import FullstackFace from "./FullstackFace";
import OraclesFace from "./OraclesFace";

// Nueva Tienda
import StoreFrancoLab from "./StoreFrancoLab";

function App() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isStoreOpen, setIsStoreOpen] = useState(false);

  const closeModal = () => setSelectedCategory(null);

  return (
    <div
      style={{
        height: "100vh", width: "100vw", overflow: "hidden",
        display: "flex", flexDirection: "column",
        background: "linear-gradient(135deg, #020024, #090979, #000000)",
        fontFamily: "Arial, sans-serif", position: "relative",
      }}
    >
      <Header />

      <main style={{ flex: 1, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", padding: "0 40px", minHeight: 0, position: "relative" }}>
        
        {/* COLUMNA IZQUIERDA */}
        <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", paddingRight: "20px", maxHeight: "85vh", overflowY: "auto" }}>
          <LeftPanel />
        </div>

        {/* COLUMNA CENTRAL */}
        <div style={{ width: "650px", height: "650px", flexShrink: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Cube onFaceClick={setSelectedCategory} />
        </div>

        {/* COLUMNA DERECHA */}
        <div style={{ flex: 1, display: "flex", justifyContent: "flex-start", paddingLeft: "20px" }}>
          <RightPanel />
        </div>

        {/* --- MODAL DE CARA DEL CUBO --- */}
        {selectedCategory && (
          <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.75)", backdropFilter: "blur(8px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }} onClick={closeModal}>
            <div style={{ width: "550px", maxHeight: "85vh", background: "rgba(0, 15, 30, 0.98)", border: "2px solid #00ffff", borderRadius: "20px", padding: "35px", position: "relative", boxShadow: "0 0 50px rgba(0, 255, 255, 0.4)", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
              <button onClick={closeModal} style={{ position: "absolute", top: "15px", right: "20px", background: "transparent", border: "none", color: "#00ffff", fontSize: "28px", cursor: "pointer" }}>×</button>

              {/* Lógica de Renderizado Dinámico */}
              {selectedCategory === "WEB3" && <Web3Face />}
              {selectedCategory === "SC SECURITY" && <SCSecurityFace />}
              {selectedCategory === "AI" && <AIFace />}
              {selectedCategory === "APP DESIGN" && <AppDesignFace />}
              {selectedCategory === "FULLSTACK" && <FullstackFace onOpenStore={() => { setIsStoreOpen(true); closeModal(); }} />}
              {selectedCategory === "ORACLES" && <OraclesFace />}
            </div>
          </div>
        )}

        {/* --- PORTAL DE LA TIENDA STOREFRANCOLAB --- */}
        {isStoreOpen && <StoreFrancoLab onClose={() => setIsStoreOpen(false)} />}

      </main>

      <Footer />
    </div>
  );
}

export default App;